import {XmlTagInfo} from '../xmlTagProvider'
import {Form} from '../form/form'
import {CheckboxItem} from "../items/checkbox";
import {CellItem} from "../items/cellItem";

export class ItemGroup<T> {

	id: string;
	type: string;
	shouldValidate: boolean;

	protected cellItems: T[] = [];
	protected variableNames: string[] = [];
	protected form: Form;

	constructor(config: XmlTagInfo, form: Form){
		this.shouldValidate = config.attributes['validate'] !== "no";
		this.id = config.attributes['id'];
		this.type = config.tag;
		this.form = form;
	}

	add(ci: T){
		this.cellItems.push(ci);
	}

	init() {}

	addVariableName(name:string) {
		this.variableNames.push(name);
	}

    /**
     * Update LocalUnknown logic:
     * 1. if localUnknown item is checked, all other items within the group are unchecked.
     * 2. if not localUnknown item is checked, uncheck all localUnknowns within the group.
     * @param changedItem Changed item
     */
    public updateLocalUnknown (changedItem: CellItem): void {
        if (changedItem.getVariable()) { // Došlo k zaškrtnutí / vyplnění hodnoty
            if (changedItem instanceof CheckboxItem && changedItem.localUnknown) { // Byl zaškrtnut checkbox s localUnknown (LU)
                for (let item of this.cellItems) { // takže projdu všechna pole ve skupině
                    // @ts-ignore
                    if (item !== changedItem) { // kromě práve zaškrtnuného LU
                        // @ts-ignore
                        item.reset(); // a sresetuji je.
                    }
                }
            } else { // A nebo byla vyplněna hodnota normálního pole, jakéhokoliv pole
                for (let item of this.cellItems) { // takže projdu pěkně všechna pole ve skupině
                    if (item instanceof CheckboxItem && item.localUnknown) { // a zaměřím se jen na checkboxy které jsou LU
                        item.reset(); // a ty sresetuji.
                    }
                }
            }
        }
    }

}
